<script>
    import { createEventDispatcher } from "svelte";
    import { scale } from "svelte/transition";
    export let img;
    const dispatch = createEventDispatcher();
    function onClickImage() {
        dispatch("onClickImage", {});
    }
</script>

<div class="image-full-preview" transition:scale={{ duration: 300 }}>
    <div class="title">{img.name}</div>
    <img src={img.url} alt="image preview" on:click={onClickImage} />
</div>
